import { gql } from "@apollo/client";

export const BULK_CREATE_SHIPPING_LOGS = gql`
    mutation bulkCreateInventoryShippingLogs($toJob: Int!, $truck: Int!, $logs: [InventoryShippingLogInputType]!) {
        bulkCreateInventoryShippingLogs(toJob: $toJob, truck: $truck, logs: $logs) {
            inventoryShippingLogs {
                id
            }
        }
    }
`